/**
 * Fitxer: Storage
 * Autor: Jordi Riu Amblàs
 * Data: 14/04/2020
 * (c) Ajuntament de Manresa - abr. 2020 - Departament de Sistemes d'Informació
 */
import * as CryptoJS from 'crypto-js';
export var eStorageType;

(function (eStorageType) {
  eStorageType[eStorageType["local"] = 0] = "local";
  eStorageType[eStorageType["session"] = 1] = "session";
})(eStorageType || (eStorageType = {})); //Retorna un storage a partir de l'storage type


export function getStorage(storageType) {
  try {
    switch (storageType) {
      case eStorageType.local:
        return localStorage;

      case eStorageType.session:
        return sessionStorage;

      default:
        return null;
    }
  } catch (e) {
    return null;
  }
}

var AjtStorage =
/** @class */
function () {
  //Constructor
  function AjtStorage(storage, keyEncrypt) {
    this.storage = storage;
    this.keyEncrypt = keyEncrypt;
  }

  ; // Funcions públiques per consultar/guardar en l'storage

  AjtStorage.prototype.set = function (key, value) {
    if (this.storage) {
      this.storage.setItem(key, this.encrypt(JSON.stringify(value)));
    }
  };

  AjtStorage.prototype.get = function (key) {
    try {
      return JSON.parse(this.decrypt(this.storage.getItem(key)) || 'null');
    } catch (e) {
      return null;
    }
  };

  AjtStorage.prototype.remove = function (key) {
    if (this.storage) {
      this.storage.removeItem(key);
    }
  };

  Object.defineProperty(AjtStorage.prototype, "encrypted", {
    // Funcions privades per encriptar i desencriptar
    get: function get() {
      return !!this.keyEncrypt;
    },
    enumerable: true,
    configurable: true
  });

  AjtStorage.prototype.encrypt = function (text) {
    return this.encrypted ? CryptoJS.AES.encrypt(text, this.keyEncrypt).toString() : text;
  };

  AjtStorage.prototype.decrypt = function (text) {
    try {
      return this.encrypted ? CryptoJS.AES.decrypt(text, this.keyEncrypt).toString(CryptoJS.enc.Utf8) : text;
    } catch (e) {
      return null;
    }
  };

  return AjtStorage;
}();

export default AjtStorage;